export default {
  path: '/pass/:pass_id?',
  name: 'r_pass',
  meta: {
    middlewares: {
      auth: null,
      menuPreferences: 'PLAN',
    },
  },
  component: () => import('../../components/pass/Pass'),
};
